import React from "react"

import CoinImg from "@shared/assets/images/img_coin.png"

import { URL, WOW_MONEY_UNIT_PRICE } from "live/constants"

const Accumulate = () => {
  return (
    <div className="coinCont coinPlus">
      <img src={CoinImg} alt="" />
      <div className="coinTxt">
        <strong>
          <span>와우머니</span>
        </strong>
        <strong>
          <span className="colorOrange">
            {WOW_MONEY_UNIT_PRICE.toLocaleString()}원
          </span>{" "}
          적립
        </strong>
      </div>
      <a
        href={URL.MY_WOW_MONEY}
        className="coinLink"
        target="_blank"
        rel="noopener noreferrer"
        title="적립금 보기"
      >
        적립금 보기
      </a>
    </div>
  )
}

export default Accumulate
